<app-notifications-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-notifications-filters>

<div class="table-container">
    <table mat-table matSort [dataSource]="notifications" multiTemplateDataRows matSortDisableClear matSortDirection="asc">
        <ng-container matColumnDef="sent_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Tempo di invio </th>
            <td mat-cell *matCellDef="let element"> {{formatSentAt(element.sent_at)}} </td>
        </ng-container>

        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Titolo </th>
            <td mat-cell *matCellDef="let element"> {{ element.title }} </td>
        </ng-container>

        <ng-container matColumnDef="body">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Contenuto </th>
            <td mat-cell *matCellDef="let element"> {{ element.body }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="add-icon-container">
              <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuova notifica"
                (click)="$event.stopPropagation(); addNotification()" color="primary">
                <mat-icon>add</mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let row" class="modify-icon-container">          
              <ng-container>
                <button mat-icon-button (click)="$event.stopPropagation(); editNotification(row)">
                  <mat-icon matTooltip="Modifica">create</mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="row">
                <button mat-icon-button (click)="sendNotification(row.id)">
                    <mat-icon matTooltip="Invia notifica">send</mat-icon>
                </button>
              </ng-container>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editNotification(row)"></tr>
    </table>

  <mat-paginator     [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSizeOptions[0]"
  [length]="total | async">
  </mat-paginator>  

</div>